/**
 * Ponto único de m.trust do bundle. Só recebe HTML que JÁ passou por
 * sanitização: SVG de badge (sanitizado no upload e no sanitizeSvg do
 * getBadgeSvg) e descrição de tier (sanitiseDescription espelhado
 * servidor+cliente). Centralizar aqui deixa a auditoria com um único
 * sink para revisar.
 */
const mithrilTrust = m.trust;
export default function trustedHtml(html) {
  return mithrilTrust(html);
}
flarum.reg.add('ziiven-verified', 'common/utils/trustedHtml', trustedHtml);